export default __webpack_public_path__ + "static/media/microsoft-login-icon.02c1e841.svg";